import React              from 'react'
import AppLayout          from '@/Layouts/AppLayout'
import OrganizationLayout from '@/Layouts/OrganizationLayout'
import { Inertia }        from "@inertiajs/inertia";
import { ReportQuestion } from "@/Components/Questions/ReportQuestion";
import LayoutIcon         from "@/Components/LayoutIcon";
import { Teams as TeamsIcon } from "@/Icons";

export default function Report({ question, team }) {

  return (
    <ReportQuestion question={question.data} derivedTeam={team.data}/>
  )
}

Report.layout = page => {

  const team = page.props?.team?.data;
  const question = page.props?.question?.data;

  const backAction = () => {
    const backUrl = route('team.overview', team);
    const previousUrl = page.props?.previous_url;
    const [previousPath] = previousUrl.split('?');

    if (backUrl === previousPath && window.history.length > 1) {
      window.history.back();
    } else {
      Inertia.visit(backUrl);
    }
  }

  return (
    <AppLayout title={`Reporting ${question?.title} on ${team?.name}`}>
      <OrganizationLayout
        header="Report"
        preamble={question?.title || 'No question found'}
        backAction={{ label: 'Back', callback: backAction }}
        icon={<LayoutIcon><TeamsIcon size={40} className="text-black"/></LayoutIcon>}
      >{page}</OrganizationLayout>
    </AppLayout>
  )
}
